import React from 'react';

import Team from '@/pages/dashboard/team';

const MyTeam = () => {
  return <Team />;
};

export default MyTeam;
